// Mock data for Digital Independence Center website

export const heroData = {
  topHeadline: "טכנולוגיה • שיווק • שותפויות",
  mainHeadline: "המרכז הישראלי לעצמאות דיגיטלית",
  subHeadline: "אנחנו בונים מותגים, מכשירים את הדור הבא של יזמי הדיגיטל, ומנהלים מערכי צמיחה לחברות המובילות במשק. הבית שלכם לעולם העסקים החדש.",
  ctaText: "גלה את המסלול שלך להצלחה"
};

export const selectorCards = [
  {
    id: "join-club",
    icon: "Users",
    title: "מועדון המשווקים",
    description: "הצטרפו למועדון המשווקים הבלעדי שלנו וקבלו גישה לקהילה, כלים מתקדמים, הדרכות שבועיות וליווי צמוד שיעזרו לכם להצליח בשיווק שותפים.",
    ctaText: "להצטרפות למועדון",
    link: "/join-club"
  },
  {
    id: "training-program",
    icon: "Handshake",
    title: "תכנית הכשרה לשיווק שותפים",
    description: "למד איך לבנות נכסים דיגיטליים שמייצרים לך הכנסה פסיבית, ללא תלות בלקוחות ובריטיינרים. השיטה שהכניסה יותר מ-35 מיליון ש\"ח למשווקים.",
    ctaText: "לבדיקת התאמה לתוכנית",
    link: "/training-program"
  },
  {
    id: "executives",
    icon: "Briefcase",
    title: "הסבה לבכירים",
    description: "מנהלים בכירים ובעלי ניסיון עסקי? למדו לבנות נכסים דיגיטליים מניבים לצד הקריירה, עם גישה אסטרטגית שמתאימה לשלב שלכם בחיים.",
    ctaText: "לבדיקת התאמה לתוכנית",
    link: "/executives"
  }
];

export const aboutData = {
  headline: "כוח של ניסיון, חדשנות ותוצאות בשטח.",
  description: "מאחורי המרכז הישראלי לעצמאות דיגיטלית עומדים רז בליזובסקי ואסי אפשטיין. כבעלים של אחת מסוכנויות ה-Performance הגדולות בישראל, אנחנו לא רק \"מלמדים\" שיווק – אנחנו חיים אותו. אנחנו חתומים על החוזים מול המותגים הגדולים, מנהלים תקציבי ענק, ומפתחים טכנולוגיות שמגדירות מחדש את כללי המשחק.",
  stats: [
    { value: "50+", label: "מותגים מנוהלים" },
    { value: "₪10M+", label: "הכנסות שותפים חודשיות" },
    { value: "1000+", label: "בוגרי התוכניות" }
  ],
  founders: [
    { name: "רז בליזובסקי", role: "שותף מייסד" },
    { name: "אסי אפשטיין", role: "שותף מייסד" }
  ]
};

export const ecosystemData = {
  headline: "האקו-סיסטם המלא לצמיחה עסקית.",
  description: "בניגוד לקורסים תיאורטיים, אנחנו יצרנו מעגל סגור של הצלחה:",
  items: [
    {
      icon: "Cpu",
      title: "הטכנולוגיה",
      description: "שימוש בכלי AI מתקדמים לייעול תהליכים."
    },
    {
      icon: "Database",
      title: "התשתית",
      description: "גישה למאגר מותגים בלעדי וחוזים סגורים."
    },
    {
      icon: "Settings",
      title: "הניהול",
      description: "סטנדרט עבודה של חברות ענק, נגיש גם ליזם הפרטי."
    }
  ]
};

export const footerData = {
  logo: "המרכז הישראלי לעצמאות דיגיטלית",
  quickLinks: [
    { label: "מסלול AI", href: "/ai-agency" },
    { label: "תכנית ההכשרה", href: "/training-program" },
    { label: "מועדון המשווקים", href: "/affiliate-club" },
    { label: "פתרונות לחברות", href: "/opm" },
    { label: "צור קשר", href: "/contact" }
  ],
  legalLinks: [
    { label: "הצהרת נגישות", href: "/accessibility" },
    { label: "תקנון", href: "/terms" },
    { label: "מדיניות פרטיות", href: "/privacy" }
  ],
  socialLinks: [
    { platform: "linkedin", href: "https://linkedin.com" },
    { platform: "facebook", href: "https://www.facebook.com/razblizo/" }
  ]
};

export const navLinks = [
  { label: "מי אנחנו", href: "#about" },
  { label: "פתרונות", href: "#solutions", hasDropdown: true },
  { label: "בלוג", href: "/blog" },
  { label: "הצעות אפיליאייט", href: "/offers" },
  { label: "צור קשר", href: "#contact" }
];

export const solutionsDropdown = [
  { label: "ליזמים מתחילים (AI Agency)", href: "/ai-agency" },
  { label: "למשווקים ושותפים (Partner Track)", href: "/partner-track" },
  { label: "לחברות וארגונים (Affiliate OPM)", href: "/opm" },
  { label: "הסבה לבכירים", href: "/executives" },
  { label: "מועדון המשווקים", href: "/affiliate-club" },
  { label: "אפיליאייט ביזנס", href: "/affiliate-business" },
  { label: "הקופסה השחורה", href: "/black-box" },
  { label: "מרד הפיפיסיסטים", href: "/ppc-rebel" }
];
